import axios from '@/axios.js'
export default {
    getSnowReport: async (resortUuid) => {
        try {
            const response = await axios.editorapi.get(`v4/snowreport/${resortUuid}`)
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },

    updateSnowReport: async (resortUuid, payload) => {
        try {
            const response = await axios.editorapi.patch(`v4/snowreport/${resortUuid}`, payload)
            return response.data
        } catch (error) {
            return new Error(error)
        }
    },

    createSnowReport: async (resortUuid, payload) => {
        try {
            const response = await axios.editorapi.post(`v4/snowreport/${resortUuid}`, payload)
            return response.data
        } catch (error) {
            return new Error(error)
        }
    },
}